module.exports = __webpack_public_path__ + "img/edit.d46bdcb1.svg";